/* eslint-disable prefer-destructuring */
import qs from 'qs';

const GET_EMAIL_LOGS_PENDING = 'GET_EMAIL_LOGS_PENDING';
const GET_EMAIL_LOGS_FULFILLED = 'GET_EMAIL_LOGS_FULFILLED';
const GET_EMAIL_LOGS_REJECTED = 'GET_EMAIL_LOGS_REJECTED';

const GET_EMAIL_LOG_PENDING = 'GET_EMAIL_LOG_PENDING';
const GET_EMAIL_LOG_FULFILLED = 'GET_EMAIL_LOG_FULFILLED';
const GET_EMAIL_LOG_REJECTED = 'GET_EMAIL_LOG_REJECTED';

const PATCH_EMAIL_LOG_PENDING = 'PATCH_EMAIL_LOG_PENDING';
const PATCH_EMAIL_LOG_FULFILLED = 'PATCH_EMAIL_LOG_FULFILLED';
const PATCH_EMAIL_LOG_REJECTED = 'PATCH_EMAIL_LOG_REJECTED';

const GET_EMAIL_BODY_PENDING = 'GET_EMAIL_BODY_PENDING';
const GET_EMAIL_BODY_FULFILLED = 'GET_EMAIL_BODY_FULFILLED';
const GET_EMAIL_BODY_REJECTED = 'GET_EMAIL_BODY_REJECTED';

const GET_SMS_LOGS_PENDING = 'GET_SMS_LOGS_PENDING';
const GET_SMS_LOGS_FULFILLED = 'GET_SMS_LOGS_FULFILLED';
const GET_SMS_LOGS_REJECTED = 'GET_SMS_LOGS_REJECTED';

const GET_SMS_LOG_PENDING = 'GET_SMS_LOG_PENDING';
const GET_SMS_LOG_FULFILLED = 'GET_SMS_LOG_FULFILLED';
const GET_SMS_LOG_REJECTED = 'GET_SMS_LOG_REJECTED';

const initialState = {
  smsList: [],
  emailList: [],
  emailBody: '...',
  emailToEdit: null,
  sms: {
    attributes: {
      mobile: '',
      body: '',
      'sent-date': '',
      response: null
    }
  },
  paging: {
    number: 1,
    size: 20,
  },
  fetching: false,
  fetched: false,
  bodyFetching: false,
  bodyFetched: false,
};

const applyLoadingState = state => ({
  ...state,
  fetching: true,
  fetched: false,
});

const applyLoadingStateForEmailBody = state => ({
  ...state,
  bodyFetching: true,
  bodyFetched: false,
});

const applyFetchedStateForEmailBody = (state, payLoad) => ({
  ...state,
  bodyFetching: false,
  bodyFetched: true,
  emailBody: payLoad.body,
});

const applyFetchedStateForEmail = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  emailToEdit: payLoad.data,
});

const applyFetchedStateForSms = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  sms: payLoad.data,
});

const applyLogsFulfilled = (state, payLoad, type) => {
  const lastPage = payLoad.links.last;
  let page = state.paging;

  if (lastPage) {
    page = qs.parse(lastPage.split('?')[1]).page;
  } else if (Object.keys(payLoad.links).length === 0) {
    page = initialState.paging;
  }

  return {
    ...state,
    fetching: false,
    fetched: true,
    [type]: payLoad.data,
    paging: page,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_BODY_PENDING: {
      return applyLoadingStateForEmailBody(state);
    }
    case GET_EMAIL_LOGS_PENDING:
    case GET_EMAIL_LOG_PENDING:
    case GET_SMS_LOG_PENDING:
    case GET_SMS_LOGS_PENDING: {
      return applyLoadingState(state);
    }
    case GET_EMAIL_LOGS_FULFILLED: {
      return applyLogsFulfilled(state, action.payLoad, 'emailList');
    }
    case GET_SMS_LOGS_FULFILLED: {
      return applyLogsFulfilled(state, action.payLoad, 'smsList');
    }
    case GET_EMAIL_BODY_FULFILLED: {
      return applyFetchedStateForEmailBody(state, action.payLoad);
    }
    case GET_EMAIL_LOG_FULFILLED: {
      return applyFetchedStateForEmail(state, action.payLoad);
    }
    case GET_SMS_LOG_FULFILLED: {
      return applyFetchedStateForSms(state, action.payLoad);
    }
    case GET_EMAIL_BODY_REJECTED:
    case GET_EMAIL_LOGS_REJECTED:
    case GET_SMS_LOGS_REJECTED: {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
  }

  return state;
};

export {
  GET_EMAIL_LOGS_PENDING,
  GET_EMAIL_LOGS_FULFILLED,
  GET_EMAIL_LOGS_REJECTED,
  GET_EMAIL_LOG_PENDING,
  GET_EMAIL_LOG_FULFILLED,
  GET_EMAIL_LOG_REJECTED,
  GET_SMS_LOGS_PENDING,
  GET_SMS_LOGS_FULFILLED,
  GET_SMS_LOGS_REJECTED,
  GET_EMAIL_BODY_FULFILLED,
  GET_EMAIL_BODY_PENDING,
  GET_EMAIL_BODY_REJECTED,
  GET_SMS_LOG_FULFILLED,
  GET_SMS_LOG_PENDING,
  GET_SMS_LOG_REJECTED,
  PATCH_EMAIL_LOG_FULFILLED,
  PATCH_EMAIL_LOG_PENDING,
  PATCH_EMAIL_LOG_REJECTED
};
